import s from './FilterPills.module.css'

export type FilterPill<K extends string> = {
  key: K
  label: string
  accessibleLabel?: string
  count?: number
}

/**
 * Text-pill filter row (the references/table-layout language): plain text
 * buttons where only the active one wears a light-gray pill fill. The quieter
 * sibling of SegmentedControl — use it for stage filters above a table, where
 * the old bordered tab cards used to sit.
 */
export function FilterPills<K extends string>({
  tabs,
  value,
  onChange,
  ariaLabel,
  className,
  variant = 'pills',
  stackCounts = false,
  dense = false,
}: {
  tabs: FilterPill<K>[]
  value: K
  onChange: (key: K) => void
  ariaLabel?: string
  className?: string
  variant?: 'pills' | 'workspace'
  stackCounts?: boolean
  /** Six lenses with counts in the 1fr pane (Invoices): .75rem labels, .2rem padding. */
  dense?: boolean
}) {
  return (
    <div className={`${s.pills} ${variant === 'workspace' ? s.workspace : ''} ${stackCounts ? s.stacked : ''} ${dense ? s.dense : ''} ${className ?? ''}`} role="tablist" aria-label={ariaLabel}>
      {tabs.map((t) => {
        const active = value === t.key
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            aria-label={t.accessibleLabel ? `${t.accessibleLabel}${t.count === undefined ? '' : ` ${t.count}`}` : undefined}
            onClick={() => onChange(t.key)}
            className={`${s.pill} ${active ? s.pillActive : ''}`}
          >
            {t.label}
            {t.count !== undefined && <span className={s.pillCount}>{t.count}</span>}
          </button>
        )
      })}
    </div>
  )
}
